import { Icon } from '@buggy/shared'
import { Button, InputNumber, type InputNumberProps } from 'antd'
import { isUndefined } from 'lodash-es'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'

const NumberPicker: FunctionComponent<
  Omit<InputNumberProps<number>, 'addonAfter' | 'addonBefore' | 'controls'>
> = ({ value, min, max, size = 'small', onChange, ...props }) => {
  return (
    <StyledInputNumber
      {...props}
      addonAfter={
        <Button
          ghost
          disabled={isUndefined(max) ? false : value === max}
          icon={<Icon name='plus' />}
          size={size}
          type='text'
          onClick={() => {
            onChange?.((value ?? 0) + 1)
          }}
        />
      }
      addonBefore={
        <Button
          ghost
          disabled={isUndefined(min) ? false : value === min}
          icon={<Icon name='minus' />}
          size={size}
          type='text'
          onClick={() => {
            onChange?.((value ?? 0) - 1)
          }}
        />
      }
      controls={false}
      max={max}
      min={min}
      size={size}
      value={value}
      onChange={onChange}
    />
  )
}

const StyledInputNumber = styled(InputNumber)`
  .ant-input-number-group-addon {
    padding: 0;

    .ant-btn {
      border: none;
    }

    .ant-btn-sm {
      height: calc(var(--ant-control-height-sm) - var(--ant-line-width) * 2);
      line-height: calc(
        var(--ant-control-height-sm) - var(--ant-line-width) * 2
      );
    }
  }

  .ant-input-number-input {
    text-align: center;
  }
`

export default NumberPicker
